module.exports = __webpack_public_path__ + "static/media/7676.79b56d5d.png";